<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật Link rút gọn {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="24">
          <el-form label-position="right" :rules="rules" :model="modelData" ref="createModel" label-width="135px" @submit.native.prevent>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên gợi nhớ" class="form-item">
                  <el-input v-model="modelData.name" class="input-seach" clearable ref="myInput"></el-input>
                </el-form-item>
                <el-form-item prop="link_short" label="Đường dẫn rút gọn" class="form-item">
                  <el-input v-model="modelData.link_short" class="input-seach" clearable></el-input>
                </el-form-item>
                <el-form-item prop="link_full" label="Đường dẫn đầy đủ" class="form-item">
                  <el-input v-model="modelData.link_full" class="input-seach" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')"
                  native-type="submit">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'MaterialCreate',
  metaInfo () {
    return {
      title: 'Link rút gọn'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      activeName: 'first',
      modelData: {
        name: '',
        link_short: '',
        link_full: '',
        status: true
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      listCategories: [],
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập Tên gợi nhớ' }
        ],
        link_short: [
          { required: true, message: 'Vui lòng nhập Đường dẫn rút gọn' }
        ],
        link_full: [
          { required: true, message: 'Vui lòng nhập Đường dẫn đầy đủ' }
        ]
      }
    }
  },
  mounted () {
    this.$refs.myInput.focus()
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('short-links/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path_sm)
      } else {
        return false
      }
    },
    makeid (length) {
      let result = ''
      let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let charactersLength = characters.length
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength))
      }
      return result
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'short-links-index', text: 'Link rút gọn' },
        { name: 'short-links-create', text: 'Cập nhật' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'short-links-index'})
    },
    // Tải dữ liệu
    fetchListCategories () {
      axios.get('short-links').then(response => {
        switch (response.code) {
          case 200:
            this.listCategories = response.data.categories
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('short-links/' + this.$route.params.id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          case 422:
            this.$router.push({name: 'home-index'})
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          console.log('Lỗi validate')
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.put('short-links/' + this.$route.params.id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            // this.$router.push({name: 'short-links-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/short-links/Update.vue